<template>
  <div>
	<div style="" v-if="sharingIsQuited === false">
        <div v-if="startedFirstRound" style="width:100%; margin:10px;">
            <v-btn dark small color="green" @click="start()">Starta CO-browsing Tryck här</v-btn>
        </div>
        <div v-else>
		    <!--<video playsinline autoplay id="screen" :srcObject ="streamObject" style="width:250px; height:auto;"></video>-->
            <v-progress-linear
                v-if="loading"
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
        </div>
	</div>
  </div>
</template>

<script>
var RTC_CONFIGURATION = {
  iceServers:[
	{url:'stun:stun.l.google.com:19302'},
	{url:'stun:stun1.l.google.com:19302'},
	{url:'stun:stun2.l.google.com:19302'},
	{url:'stun:stun3.l.google.com:19302'},
	{url:'stun:stun4.l.google.com:19302'},
	{
		url: 'turn:numb.viagenie.ca',
		credential: 'muazkh',
		username: 'webrtc@live.com'
	}
]};
var caller;

export default {
    data() {
        return {
            startedFirstRound: true,
            streamObject: [],
            loading: true,
            sharingIsQuited: false,
            intervalRTC: '',
            restart: false,
        }
    },

    sockets: { 
        candidate: function () {
            caller.close();
        },
        candidate: function (candidate) {
            caller.addIceCandidate(candidate);
        },
        disconnect: function (data) {
            this.sharingIsQuited = true;
        },
        answer: function(answer) {
            caller.setRemoteDescription(answer);
        },
        hangup: function() {
            this.sharingIsQuited = false;
        },

    },
    destroyed() {
            this.$socket.emit('hangup', 'caller');
            this.stop();
    },
    mounted() {
        window.onunload = window.onbeforeunload = () => {
            this.stop();
        };
    },
    methods: {
        sendOffer(offer) {
            this.$socket.emit('offer', offer);
        },
        sendCandidate(candidate) {
            this.$socket.emit('candidate', candidate);
        },
        getStream() {
            return new Promise((resolve, reject) => {
                navigator.mediaDevices.getDisplayMedia({ audio: true, video: true }).then((mediaStream) => {
                    resolve(mediaStream);
                    clearInterval(this.intervalRTC);
                }).catch(err => {
                    alert("Något gick fel pröva igen",err);
                    this.stop();
                })
            });
        },
        makePeerConnection(stream) {
            
            if (caller) { 
                caller.close(); 
            }
            caller = new RTCPeerConnection(RTC_CONFIGURATION);

            caller.addStream(stream);
            caller.onicecandidate = (event) => {
                if (event.candidate != null) {
                 this.sendCandidate(event.candidate);
                }
            }

            this.intervalRTC = setInterval(() => {
                    let state = caller.iceConnectionState;
                    if(state != 'connected') {
                        this.makeOffer();
                    }
            }, 1500);

            this.makeOffer();

        },
        makeOffer() {
            this.loading = false;
            caller.createOffer().then((offer) => {
                return caller.setLocalDescription(offer);
            }).then(() => {
                this.sendOffer(caller.localDescription);
            });
        },
        stop() {
            this.restart = true;
            clearInterval(this.intervalRTC);
            this.$socket.emit('hangup', 'caller');
            this.$store.dispatch("restartScreenSharing");

        },
        start() {
            if(this.restart === true) {
                this.sharingIsQuited = false;
                this.startedFirstRound = true;
            } else {
                this.startedFirstRound = false;
            }
            
            const caseId = localStorage.getItem('rand');
            this.$socket.emit('join', {type: 'caller', room: caseId ,unique: Math.random(192391231123123) });

            this.getStream().then((stream) => {        
                this.makePeerConnection(stream);
                stream.getVideoTracks()[0].addEventListener('ended', () => {
                    this.stop();
                });
            });
        }

    }

}

</script>

<style>

</style>